import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PopupComponent } from '@app/components/popup/popup.component';
import { RegistrationWorkflowFormsComponent } from '@app/modules/registration-workflow/registration-workflow-forms/registration-workflow-forms.component';
import { BaseService } from '@app/system/services/base.service';
import { DetectDeviceService } from '@app/system/services/detect-device.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { LocaleService } from '@app/system/services/locale.service';

@Component({
	selector: 'app-internal-event-detail',
	templateUrl: './internal-event-detail.component.html',
	styleUrls: ['./internal-event-detail.component.scss']
})
export class InternalEventDetailComponent implements OnInit {

	@Input() resourceDetail: any = {};
	@Input() popupRef: any = {};
	@Output() reloadResource = new EventEmitter();
	@Output() readLogEmit = new EventEmitter();

	currentUser;
	showCount = false;
	skillMPermission = false;
	constructor(
		public locale: LocaleService,
		private popup: MatDialog,
		public detectDevice: DetectDeviceService,
		public gfService: GlobalFunctionService,
		private baseService: BaseService
	) {
		this.currentUser = this.gfService.sessionUser;
	}

	ngOnInit(): void {
		this.showCount = this.baseService.checkAccessControl(['REG001']);
		if (this.baseService.checkModuleAccess('M13')) {
			this.skillMPermission = true;
		}
		if (this.resourceDetail && this.resourceDetail.infoFields) {
			if (this.resourceDetail.infoFields.time) {
				this.resourceDetail.eventTime = this.gfService.dateFormat(this.resourceDetail.infoFields.time, 'shortTime');
			}
			if (this.resourceDetail.resourceTypeID && this.resourceDetail.resourceTypeID.key && this.resourceDetail.infoFields.startDate
				&& this.resourceDetail.infoFields.endDate) {
				// if (this.resourceDetail.infoFields.date.length) {
				const startDate: any = new Date(this.resourceDetail.infoFields.startDate);
				const endDate: any = new Date(this.resourceDetail.infoFields.endDate);
				startDate.setHours(0, 0, 0, 0);
				endDate.setHours(0, 0, 0, 0);
				if (Date.parse(startDate) === Date.parse(endDate)) {
					this.resourceDetail.eventDate = `${this.gfService.dateFormat(this.resourceDetail.infoFields.startDate, 'd')} ${this.gfService.dateFormat(this.resourceDetail.infoFields.startDate, 'MMM')}`;
				} else {
					this.resourceDetail.eventDate = `${this.gfService.dateFormat(this.resourceDetail.infoFields.startDate, 'd')} ${this.gfService.dateFormat(this.resourceDetail.infoFields.startDate, 'MMM')} - ${this.gfService.dateFormat(this.resourceDetail.infoFields.endDate, 'd')} ${this.gfService.dateFormat(this.resourceDetail.infoFields.endDate, 'MMM')}`;
				}
				const date: any = new Date(this.resourceDetail.infoFields.endDate);
				const timeDate = new Date(this.resourceDetail.infoFields.time);
				date.setHours(timeDate.getHours(), timeDate.getMinutes(), timeDate.getSeconds(), timeDate.getMilliseconds());
				if (Date.now() > Date.parse(date)) {
					this.resourceDetail.datePassed = true;
				} else {
					this.resourceDetail.datePassed = false;
				}
				// }
			}
		}
	}

	requestForm(tabName: string, additionalInfo: any = {}) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: RegistrationWorkflowFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'requestRegistrationList'
					},
					{
						variableName: 'record',
						value: this.resourceDetail
					},
					{
						variableName: 'tabName',
						value: tabName
					}
				]
			},
			disableClose: true,
			autoFocus: false,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result && typeof result === 'object') {
				if (result.updated) {
					this.reloadResource.emit(true);
				}
			}
		});
	}

	embedLink() {
		if (navigator.onLine) {
			let url;
			if (this.resourceDetail.resourceTypeID) {
				if (this.resourceDetail.infoFields && this.resourceDetail.infoFields.meetingLink) {
					url = this.resourceDetail.infoFields.meetingLink;
				}
			}
			this.gfService.windowNavigate(url, '_blank');
		}
	}

	emitReadLog() {
		this.readLogEmit.emit(true);
	}
}
